import { removeValue } from './array';

export class Watcher {
    #handlers = [];

    watch(handler, ...args) {
        if(typeof handler !== 'function')
            throw 'handler must be a function';
        if(this.#handlers.includes(handler))
            throw 'handler already registered';

        this.#handlers.push(handler);
        args.push(true);
        handler(...args);
    }

    unwatch(handler) {
        removeValue(this.#handlers, handler);
    }

    call(...args) {
        args.push(false);
        for(const handler of this.#handlers)
            handler(...args);
    }
}

export class Watchers {
    #watchers = new Map;

    #getWatcher(name) {
        const watcher = this.#watchers.get(name);
        if(watcher === undefined)
            throw 'undefined watcher name';
        return watcher;
    }

    watch(name, handler, ...args) {
        this.#getWatcher(name).watch(handler, ...args);
    }

    unwatch(name, handler) {
        this.#getWatcher(name).unwatch(handler);
    }

    define(names) {
        if(typeof names === 'string')
            this.#watchers.set(names, new Watcher);
        else if(Array.isArray(names))
            for(const name of names)
                this.#watchers.set(name, new Watcher);
        else
            throw 'names must be an array of names or a single name';
    }

    call(name, ...args) {
        this.#getWatcher(name).call(...args);
    }
}
